import { get, isEmpty } from 'lodash'

const isLoading = state => get(state, 'offersConfigurationInit.loading')
const hasErrors = state => !isEmpty(get(state, 'offersConfigurationInit.error'))

export const selectors = {
  isLoading,
  hasErrors,
}
